"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VALIDATORS_METADATA = exports.ValidatorsMetaFacade = void 0;

var the_lodash_1 = __importDefault(require("the-lodash"));

var validator_id_1 = require("../validator-id");

var validators_1 = require("./validators");

var categories_1 = require("./categories");

var ValidatorsMetaFacade =
/** @class */
function () {
  function ValidatorsMetaFacade() {
    this._categories = [];
    this._categoryDict = {};

    for (var _i = 0, VALIDATOR_CATEGORIES_1 = categories_1.VALIDATOR_CATEGORIES; _i < VALIDATOR_CATEGORIES_1.length; _i++) {
      var categoryInfo = VALIDATOR_CATEGORIES_1[_i];

      if (!this._categoryDict[categoryInfo.id]) {
        var categoryData = {
          categoryId: categoryInfo.id,
          category: categoryInfo.name,
          validators: []
        };
        this._categoryDict[categoryInfo.id.toString()] = categoryData;

        this._categories.push(categoryData);
      }
    }

    for (var _a = 0, VALIDATOR_IDs_1 = validator_id_1.VALIDATOR_IDs; _a < VALIDATOR_IDs_1.length; _a++) {
      var validatorId = VALIDATOR_IDs_1[_a];
      var validatorDocs = this.getValidatorDocs(validatorId);

      var categoryData = this._categoryDict[validatorDocs.category.toString()];

      if (categoryData) {
        categoryData.validators.push(validatorDocs);
      }
    }

    for (var _b = 0, _c = this._categories; _b < _c.length; _b++) {
      var categoryData = _c[_b];
      categoryData.validators = the_lodash_1.default.orderBy(categoryData.validators, function (x) {
        return x.subCategory;
      });
    }
  }

  Object.defineProperty(ValidatorsMetaFacade.prototype, "categories", {
    get: function get() {
      return this._categories;
    },
    enumerable: false,
    configurable: true
  });

  ValidatorsMetaFacade.prototype.getValidatorDocs = function (id) {
    return validators_1.builder.get(id);
  };

  return ValidatorsMetaFacade;
}();

exports.ValidatorsMetaFacade = ValidatorsMetaFacade;
exports.VALIDATORS_METADATA = new ValidatorsMetaFacade();